module.exports = __webpack_public_path__ + "img/27257bb.png";